/**
 * Trigger a client-side download (spec §4.1: save via the browser, no server
 * round-trip). Kept tiny and separate so the Converter stays unit-testable; the
 * DOM plumbing here is exercised by the e2e suite.
 */

/** Push a Blob to the browser as a download named `filename`. */
function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Download text content (used for SRT/VTT/SBV/ASS and text Pro formats). */
export function downloadText(filename: string, text: string, mime = 'text/plain'): void {
  downloadBlob(filename, new Blob([text], { type: `${mime};charset=utf-8` }));
}

/** Download raw bytes (used for binary Pro formats such as EBU-STL). */
export function downloadBytes(
  filename: string,
  bytes: Uint8Array,
  mime = 'application/octet-stream',
): void {
  // Uint8Array satisfies BlobPart at runtime; the cast sidesteps the DOM lib's
  // ArrayBuffer-vs-ArrayBufferLike generic friction.
  downloadBlob(filename, new Blob([bytes as BlobPart], { type: mime }));
}
